(ns teamoesterreich.user-mode.wana-help.nokat.helping-nokat
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.check :refer [check]]
    [reagent-material-ui.icons.check :refer [check]]
    [reagent-material-ui.icons.close :refer [close]]
    [reagent-material-ui.icons.expand-less :refer [expand-less]]
    [reagent-material-ui.icons.expand-more :refer [expand-more]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]

    [reagent-material-ui.icons.person :refer [person]]

    [reagent-material-ui.icons.save :refer [save]]
    [reagent.core :as r]
    [teamoesterreich.config :as config]
    [teamoesterreich.firebase.remote-config :as remote-config]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.ui-helper.are-you-sure-modal :as ays-modal]
    [teamoesterreich.user-mode.wana-help.nokat.checks :as h-check]
    [teamoesterreich.util.log :as log]
    ))





(defn save-user [user-obj]
  (a/set-user-details user-obj))


(defn wanado-checkbox [val-fn changed-fn on-change-fn]
  (fn [name text key]
    [mui/grid
     {:container false
      :item      true
      :md        12                                         ;medium: 960px
      :xs        12                                         ;extra-small: 0px
      :style     {:padding "0px" :backgroundColor (if (changed-fn key) "#ffd6d2" "#ffffff")}
      }

     [mui/form-control-label
      {
       :control (r/as-element
                  [mui/checkbox {
                                 :checked  (val-fn key)
                                 :color    "primary"
                                 :onChange (on-change-fn key)
                                 }])
       :label   (str name)
       }
      ]
     [:br]
     [:span {:style {:paddingLeft "30px"}} text]
     ]
    ))

(defn mission-block [title message]

  [mui/grid
   {:container false
    :item      true
    :xs        12                                           ;extra-small: 0px
    :style     {:padding "15px 15px 0 15px"}
    }
   [:h2
    title]
   [:p
    message
    ]
   [:hr]
   ]
  )

(defn wanado-block [!hide-form u-wanado-checkbox save-fn do-save?]
  [mui/grid
   {:container  true
    :direction  "row"
    :justify    "space-between"
    :alignItems "flex-start"
    :spacing    1
    }



   [mui/grid
    {:container false
     :item      true
     :xs        12                                          ;extra-small: 0px
     :style     {}
     }
    [:h4
     "Was ich tun will "
     [mui/icon-button {:disabled do-save?
                       :onClick  #(reset! !hide-form (not @!hide-form))} (if @!hide-form [expand-less] [expand-more])]]

    ]

   (when (not @!hide-form)
     (u-wanado-checkbox "... für \"Einmal-Aufgaben\"."
                        "(z.B. Individuelle Spontanhilfe)"
                        [:help :NormEinmalAufgaben]))
   (when (not @!hide-form)

     (u-wanado-checkbox "... zur Unterstützung bei Projekten."
                        ""
                        [:help :NormProjekten]))
   (when (not @!hide-form)

     (u-wanado-checkbox "... zur Unterstützung in der Logistik."
                        ""
                        [:help :NormLogistik]))
   (when (not @!hide-form)
     (u-wanado-checkbox "... zur Unterstützung bei Rotkreuz-Veranstaltungen."
                        ""
                        [:help :NormRotkreuzVeranstaltungen]))
   (when (not @!hide-form)
     (u-wanado-checkbox "... zur administrativen Unterstützung."
                        ""
                        [:help :NormAdministrativen]))
   (when (not @!hide-form)
     (u-wanado-checkbox "... zur Durchführung von Marketing-Aufgaben."
                        ""
                        [:help :NormCampaigning]))
   (when (not @!hide-form)
     (u-wanado-checkbox "... zur Unterstützung bei anderen Hilfsaktivitäten."
                        ""
                        [:help :NormHilfsaktivitäten]))


   (when (not @!hide-form)

     [mui/grid
      {:container false
       :item      true
       :md        5                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       :style     {:padding "15px"}
       }
      [mui/button
       {:variant   "contained"
        :color     "primary"
        :disabled  (not do-save?)
        :startIcon (r/as-element [save])
        :class     "bottom-button"
        :onClick   save-fn
        }
       "Speichern"]])])



(defn needs-login []
  [mui/grid
   {:container false
    :item      true
    :xs        12                                           ;extra-small: 0px
    :style     #js {:padding "15px"}
    }
   [:h1
    "Nicht angemeldet"]
   [:div
    [:div {:style {}}
     (txt/txt :helping "Du must im angemeldet sein um mitmachen zu können!")]
    [mui/button
     {:variant "outlined"
      :color   "secondary"
      :style   #js {:margin "10px 0 10px 10px" :min-width "200px"}
      :onClick #(a/open-login)
      }
     "Ich will mich anmelden"]]]
  )

(defn get-it []
  (let [!st (r/atom {:wanado-form {} :hide-form false :block false})]
    (fn []
      (let [!status-kat (r/cursor store/app-state [:actual-user :status-nokat])
            !request-kat (r/cursor store/app-state [:actual-user :request-nokat])
            request-kat-fn #(a/set-user-details {:request-nokat true})
            request-out-kat-fn #(a/set-user-details {:request-nokat false :status-nokat false})


            !actual-user (r/cursor store/app-state [:actual-user])
            !wanado-form (r/cursor !st [:wanado-form])
            !lose-data-modal (r/cursor !wanado-form [:show-lose-data-form-modal])
            !hide-form (r/cursor !st [:hide-form])


            u-on-change-fn (fn [keys] (fn [_ val] (swap! !wanado-form assoc-in keys val) (log/log "OnChange" keys val @!wanado-form)))
            u-val-fn (fn [keys] (if (nil? (get-in @!wanado-form keys)) (get-in @!actual-user keys) (get-in @!wanado-form keys)))
            u-changed?-fn (fn [keys] (and (not (nil? (get-in @!wanado-form keys)))
                                          (not= (get-in @!wanado-form keys) (get-in @!actual-user keys))))
            do-save? (or
                       (u-changed?-fn [:help :NormEinmalAufgaben])
                       (u-changed?-fn [:help :NormProjekten])
                       (u-changed?-fn [:help :NormLogistik])
                       (u-changed?-fn [:help :NormRotkreuzVeranstaltungen])
                       (u-changed?-fn [:help :NormAdministrativen])
                       (u-changed?-fn [:help :NormCampaigning])
                       (u-changed?-fn [:help :NormHilfsaktivitäten])
                       )
            u-wanado-checkbox (wanado-checkbox u-val-fn u-changed?-fn u-on-change-fn)
            save-fn (fn []
                      (log/out "save form")
                      (save-user @!wanado-form)
                      (swap! !st assoc :wanado-form {})
                      ;(.scrollTo js/window 0 0)
                      ;(a/set-page-back)
                      )


            real-back-fn a/set-page-back
            back-fn (fn [_]
                      (log/out "back-fn called")
                      (if do-save?
                        (reset! !lose-data-modal true)
                        (real-back-fn)))

            ]
        (a/set-bottom-action-fn back-fn (when do-save? save-fn))

        [mui/grid
         {:container  true
          :direction  "column"
          :justify    "center"
          :alignItems "center"
          :spacing    4
          :style      {:marginTop "25px"}
          }
         [mui/grid
          {:container false
           :item      true
           :md        6                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           }
          [mui/paper {:class "" :style {:textAlign "left" :padding "25px"}}
           [ays-modal/are-you-sure-modal !lose-data-modal "Dieses Formular hat nicht gespeicherte Daten. Willst du es wirklich schließen?" "Eingabe verwerfen" real-back-fn]
           [mui/grid
            {:container  true
             :direction  "row"
             :justify    "space-between"
             :alignItems "flex-start"
             :spacing    1
             }
            [mui/grid
             {:container false
              :item      true
              :xs        12                                 ;extra-small: 0px
              :style     {:padding "15px"}
              }
             [:h1 (txt/txt :helping "Ohne-Katastrophe-Titel")]
             [:div {:dangerouslySetInnerHTML {:__html (or (remote-config/get-string "help_card_no_emergency_explain_html") "")}}]

             ]


            (when (not (:tom-id @!actual-user))
              [needs-login !actual-user])

            (when (and (:tom-id @!actual-user) (not @!request-kat))

              [mui/grid
               {:container false
                :item      true
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [:h1
                "Voraussetzungen"]



               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"}
                 (if (h-check/check-profile? !actual-user) [check] [close])
                 ]
                [:div {:class "check-line-text"}
                 "Ausgefülltes persönliches Profil"]
                [mui/button {:variant   "outlined"
                             :color     "primary"
                             :disabled  do-save?
                             :startIcon (r/as-element [person])
                             :onClick   #(a/set-page :wanaHelpKat-profile-personal)
                             }
                 "Profil"]
                ]
               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"}
                 (if (h-check/check-qualification? !actual-user) [check] [close])
                 ]
                [:div {:class "check-line-text"}
                 "`Qualifikationen` ausgefüllt"]

                [mui/button {:variant   "outlined"
                             :color     "primary"
                             :disabled  do-save?
                             :startIcon (r/as-element [person])
                             :onClick   #(a/set-page :wanaHelpKat-profile-qualifications)
                             }
                 "Qualifikationen"]
                ]
               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"}
                 (if (h-check/check-email? !actual-user) [check] [close])
                 ]
                [:div {:class "check-line-text"}
                 "Verifiziertes E-Mail Adresse"]
                ]
               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"}
                 (if (h-check/check-handy? !actual-user) [check] [close])
                 ]
                [:div {:class "check-line-text"}
                 "Verifiziertes Mobiltelefon"]
                ]
               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"}
                 (if (h-check/check-identity? !actual-user) [check] [close])
                 ]
                [:div {:class "check-line-text"}
                 "Identität bestätigt [optional]"]
                ]
               (when-not (= "tbonn" config/CLIENT)
                 [:div {:class "helping-check-line"}
                  [:div {:class "check-line-icon"}
                   (if (h-check/check-wanado? !actual-user) [check] [close {:style {:color "#a66"}}])]
                  [:div {:class "check-line-text"}
                   "`Was ich tun will` ausgefüllt (min 1 Punkt)"]
                  [wanado-block !hide-form u-wanado-checkbox save-fn do-save?]
                  ])
               ])

            (when (and (:tom-id @!actual-user) @!request-kat)
              [mui/grid
               {:container false
                :item      true
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [:h1
                "Voraussetzungen"]


               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"}
                 (if (h-check/check-profile? !actual-user) [check] [close])
                 ]
                [:div {:class "check-line-text"}
                 "Ausgefülltes persönliches Profil"]
                [mui/button {:variant   "outlined"
                             :color     "primary"
                             :disabled  do-save?
                             :startIcon (r/as-element [person])
                             :onClick   #(a/set-page :wanaHelpKat-profile-personal)
                             }
                 "Profil"]
                ]
               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"}
                 (if (h-check/check-qualification? !actual-user) [check] [close])
                 ]
                [:div {:class "check-line-text"}
                 "`Qualifikationen` ausgefüllt"]

                [mui/button {:variant   "outlined"
                             :color     "primary"
                             :disabled  do-save?
                             :startIcon (r/as-element [person])
                             :onClick   #(a/set-page :wanaHelpKat-profile-qualifications)
                             }
                 "Qualifikationen"]
                ]
               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"}
                 (if (h-check/check-email? !actual-user) [check] [close])
                 ]
                [:div {:class "check-line-text"}
                 "Verifiziertes E-Mail Adresse"]
                ]
               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"}
                 (if (h-check/check-handy? !actual-user) [check] [close])
                 ]
                [:div {:class "check-line-text"}
                 "Verifiziertes Mobiltelefon"]]

               [:div {:class "helping-check-line"}
                [:div {:class "check-line-icon"}
                 (if (h-check/check-identity? !actual-user) [check] [close])
                 ]
                [:div {:class "check-line-text"}
                 "Identität bestätigt [optional]"]
                ]

               (when-not (= "tbonn" config/CLIENT)
                [:div {:class "helping-check-line"}
                 [:div {:class "check-line-icon"}
                  (if (h-check/check-wanado? !actual-user) [check] [close {:style {:color "#a66"}}])]
                 [:div {:class "check-line-text"}
                  "`Was ich tun will` ausgefüllt (min 1 Punkt)"]
                 [wanado-block !hide-form u-wanado-checkbox save-fn do-save?]
                 ])

               ;
               ;[:br]
               ;[:br]
               ;[:h1
               ; "Was ich für einen TÖ Katastrophenhelfer Einsatz brauche"]
               ;[:p "!! Hier kommt ein Beschreibungstext hinein !! "]
               ;
               ;[:br]
               ;[:br]
               ;[:h1
               ; "Meine Einsätze als TÖ Katastrophenhelfer"]

               ;[mission-block "Neuer Test Einsatz von " "01.08.2018 - 08:00 Uhr, ganz Österreich\nHitzewelle Anfang August 2018"]

               ]

              )

            (when (and (:tom-id @!actual-user) @!request-kat)
              [mui/grid
               {:container false
                :item      true
                :md        12                               ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/button
                {:variant  "outlined"
                 :color    "secondary"
                 :style    #js {:margin "10px 0 10px 10px" :min-width "200px"}
                 :disabled true
                 }
                "Ich helfe schon"]


               [mui/button
                {:variant  "outlined"
                 :disabled do-save?
                 :style    #js {:margin "10px 0 10px 10px" :min-width "200px" :float "right"}
                 :onClick  #(request-out-kat-fn)
                 }
                "Abmelden"]])

            (when (and (:tom-id @!actual-user) (not @!request-kat))
              [mui/grid
               {:container false
                :item      true
                :md        12                               ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/button
                {:variant  "outlined"
                 :color    "secondary"
                 :disabled do-save?
                 :style    #js {:margin "10px 0 10px 10px" :min-width "200px"}
                 :onClick  #(request-kat-fn)
                 }
                "Ich will mitmachen."]]

              )

            [mui/grid
             {:container false
              :item      true
              :md        5                                  ;medium: 960px
              :xs        12                                 ;extra-small: 0px
              :style     {:padding "15px"}
              }
             [mui/button
              {:variant   "contained"
               :disabled  do-save?
               :style     {:margin "10px 0 10px 10px" :width "200px"}
               :onClick   #(a/set-page-back)
               :startIcon (r/as-element [keyboard-arrow-left])
               }
              "Zurück"]]

            ]]]]
        ))))


